module.exports = __webpack_public_path__ + "img/w2-b2.eca9d277.jpg";